import { useEffect } from 'react';
import decimal from 'decimal.js';
import {
  SelectSessionButton,
} from './KeysAndSigningUI';
import {
  Header,
  ForDevelopment,
} from './MonacottoMiscUI';
import {
  TextLine3,
} from './UtilComponents';
import {
  useGlobalStateSelector,
  words,
  wallet,
  priceDigit,
} from './globalState';
import {
  handleClickSignExhibit,
  handleClickSendToken,
} from './exhibit';
import {
  handleClickSendMona,
  handleClickSignPurchase,
} from './itemDetail';
import {
  handleClickGetExhibitHistory,
  handleClickGetPurchaseHistory,
  handleClickGetSalesHistory,
  handleClickGetRoyaltyHistory,
  handleClickSignCancelExhibit,
  handleClickSignChangeExhibit,
} from './history';
import {
  keepKeyPairsInMemory,
  handleClickNfc,
  getSecretsFromNativeApp,
  handleClickMpurse,
  buildActiveCertification,
} from './keysAndSigning';
import {
  handleClickAddressHistory,
} from './monacottoMisc';
import {
  devLog,
  localTime,
  handleClickScanQr,
} from './utils';
import iconMpurse from './mpurse.png';
import iconSign from './history_edu_FILL0_wght400_GRAD0_opsz48.svg';
import iconDetail from './more_horiz_FILL0_wght400_GRAD0_opsz48.svg';
import iconList from './format_list_bulleted_FILL0_wght400_GRAD0_opsz48.svg';
import iconSearch from './search_FILL0_wght400_GRAD0_opsz48.svg';
import iconCircleLeft from './arrow_circle_left_FILL0_wght400_GRAD0_opsz48.svg';
import iconCircleRight from './arrow_circle_right_FILL0_wght400_GRAD0_opsz48.svg';

// HISTORY
function History() {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const cookies = useGlobalStateSelector( ({ cookies }) => cookies );
  const setCookie = useGlobalStateSelector( ({ setCookie }) => setCookie );
  let combinedAction; 
  let historyItems;
  let historyFunction;
  let arrowRight;
  let arrowLeft;
  let addressType;
  let addressFace;

  // 複合アクション
  if (state.getHistory.action === 'exhibit') {
    combinedAction = 'exhibit';
  }
  else if (state.getHistory.action === 'purchase') {
    combinedAction = 'purchase';
  }
  else if (state.getHistory.action === 'sales') {
    combinedAction = 'sales';
  }
  else { // royalty
    if (state.getHistory.addressType === 'addressOwner') {
      combinedAction = 'royaltyAddressOwner';
    }
    else { // addressPayRoyaltyTo
      combinedAction = 'royaltyAddressPayRoyaltyTo';
    }
  }

  if (combinedAction === 'exhibit') {
    if (state.exhibitHistory[state.getHistory.addressMain] !== undefined && state.exhibitHistory[state.getHistory.addressMain].exhibit !== undefined) {
      historyItems = state.exhibitHistory[state.getHistory.addressMain].exhibit.map( record => {
        if (true) {
          return <ExhibitRecord record={record} />
        }
        else {
          return null;
        }
      });

      historyItems.unshift(<ExhibitRecordTitle />);
    }
    else {
      historyItems = [<ExhibitRecordTitle />];
    }

    historyFunction = async (pagingIndex) => {
      const result = await handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, pagingIndex);

      if (result?.message === 'nfcRequired') {
        const callback = (keyPairs) => {
          handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, pagingIndex, null, null, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickNfc(state, dispatch, callback);
      }
      else if (result?.message === 'nfcNativeRequired') {
        const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

        handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, pagingIndex, null, null, keyPairs);
        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
      }
      else if (result?.message === 'bcRequired') {
        const callback = (keyPairs) => {
          handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, pagingIndex, null, null, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickScanQr(state, dispatch, callback);
      }
    };
  }
  else if (combinedAction === 'purchase') {
    if (state.purchaseHistory[state.getHistory.addressMain] !== undefined && state.purchaseHistory[state.getHistory.addressMain].purchase !== undefined) {
      historyItems = state.purchaseHistory[state.getHistory.addressMain].purchase.map( record => {
        if (true) {
          return <PurchaseRecord record={record} />
        }
        else {
          return null;
        }
      });

      historyItems.unshift(<PurchaseRecordTitle />);
    }
    else {
      historyItems = [<PurchaseRecordTitle />];
    }

    historyFunction = async (pagingIndex) => {
      const result = await handleClickGetPurchaseHistory(state, dispatch, cookies, setCookie, pagingIndex);

      if (result?.message === 'nfcRequired') {
        const callback = (keyPairs) => {
          handleClickGetPurchaseHistory(state, dispatch, cookies, setCookie, pagingIndex, null, null, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickNfc(state, dispatch, callback);
      }
      else if (result?.message === 'nfcNativeRequired') {
        const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

        handleClickGetPurchaseHistory(state, dispatch, cookies, setCookie, pagingIndex, null, null, keyPairs);
        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
      }
      else if (result?.message === 'bcRequired') {
        const callback = (keyPairs) => {
          handleClickGetPurchaseHistory(state, dispatch, cookies, setCookie, pagingIndex, null, null, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickScanQr(state, dispatch, callback);
      }
    };
  }
  else if (combinedAction === 'sales') {
    if (state.salesHistory[state.getHistory.addressMain] !== undefined && state.salesHistory[state.getHistory.addressMain].sales !== undefined) {
      historyItems = state.salesHistory[state.getHistory.addressMain].sales.map( record => {
        if (true) {
          return <SalesRecord record={record} />
        }
        else {
          return null;
        }
      });

      historyItems.unshift(<SalesRecordTitle />);
    }
    else {
      historyItems = [<SalesRecordTitle />];
    }

    historyFunction = async (pagingIndex) => {
      const result = await handleClickGetSalesHistory(state, dispatch, cookies, setCookie, pagingIndex);

      if (result?.message === 'nfcRequired') {
        const callback = (keyPairs) => {
          handleClickGetSalesHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickNfc(state, dispatch, callback);
      }
      else if (result?.message === 'nfcNativeRequired') {
        const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

        handleClickGetSalesHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
      }
      else if (result?.message === 'bcRequired') {
        const callback = (keyPairs) => {
          handleClickGetSalesHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickScanQr(state, dispatch, callback);
      }
    };
  }
  else if (combinedAction === 'royaltyAddressOwner') {
    if (state.royaltyAddressOwnerHistory[state.getHistory.addressMain] !== undefined && state.royaltyAddressOwnerHistory[state.getHistory.addressMain].royalty !== undefined) {
      historyItems = state.royaltyAddressOwnerHistory[state.getHistory.addressMain].royalty.map( record => {
        if (true) {
          return <RoyaltyRecord record={record} />
        }
        else {
          return null;
        }
      });

      historyItems.unshift(<RoyaltyRecordTitle />);
    }
    else {
      historyItems = [<RoyaltyRecordTitle />];
    }

    historyFunction = async (pagingIndex) => {
      const result = await handleClickGetRoyaltyHistory(state, dispatch, cookies, setCookie, pagingIndex);

      if (result?.message === 'nfcRequired') {
        const callback = (keyPairs) => {
          handleClickGetRoyaltyHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickNfc(state, dispatch, callback);
      }
      else if (result?.message === 'nfcNativeRequired') {
        const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

        handleClickGetRoyaltyHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
      }
      else if (result?.message === 'bcRequired') {
        const callback = (keyPairs) => {
          handleClickGetRoyaltyHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickScanQr(state, dispatch, callback);
      }
    };
  }
  else { // royaltyAddressPayRoyaltyTo
    if (state.royaltyAddressPayRoyaltyToHistory[state.getHistory.addressMain] !== undefined && state.royaltyAddressPayRoyaltyToHistory[state.getHistory.addressMain].royalty !== undefined) {
      historyItems = state.royaltyAddressPayRoyaltyToHistory[state.getHistory.addressMain].royalty.map( record => {
        if (true) {
          return <RoyaltyRecord record={record} />
        }
        else {
          return null;
        }
      });

      historyItems.unshift(<RoyaltyRecordTitle />);
    }
    else {
      historyItems = [<RoyaltyRecordTitle />];
    }

    historyFunction = async (pagingIndex) => {
      const result = await handleClickGetRoyaltyHistory(state, dispatch, cookies, setCookie, pagingIndex);

      if (result?.message === 'nfcRequired') {
        const callback = (keyPairs) => {
          handleClickGetRoyaltyHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickNfc(state, dispatch, callback);
      }
      else if (result?.message === 'nfcNativeRequired') {
        const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, language: state.language, network: state.networkMona });

        handleClickGetRoyaltyHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
      }
      else if (result?.message === 'bcRequired') {
        const callback = (keyPairs) => {
          handleClickGetRoyaltyHistory(state, dispatch, cookies, setCookie, pagingIndex, keyPairs);
          keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });
        };

        handleClickScanQr(state, dispatch, callback);
      }
    };
  }


  // 矢印

  if ( state.getHistory.pagingIndex[combinedAction] >= 1 ) {
    arrowLeft = <div>
      <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2 '
        onClick={ () => { historyFunction(state.getHistory.pagingIndex[combinedAction] - 1) } }
      >
        <img className='size2x2' src={iconCircleLeft} alt='left' />
      </button>
    </div>
  }
  else {
    arrowLeft = <div>
      <button className='size2x2Large backgroundColorTransparent borderNone' disabled={true} >
        <div className='size2x2' />
      </button>
    </div>
  }

  if ( state.getHistory.lastEvaluatedKey[combinedAction][state.getHistory.pagingIndex[combinedAction]] !== undefined &&
       state.getHistory.lastEvaluatedKey[combinedAction][state.getHistory.pagingIndex[combinedAction]] !== null ) {
    arrowRight = <div>
      <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2 '
        onClick={ () => { historyFunction(state.getHistory.pagingIndex[combinedAction] + 1) } }
      >
        <img className='size2x2' src={iconCircleRight} alt='right' />
      </button>
    </div>
  }
  else {
    arrowRight = <div>
      <button className='size2x2Large backgroundColorTransparent borderNone' disabled={true} >
        <div className='size2x2' />
      </button>
    </div>
  }

  // addressType

  if (state.getHistory.action === 'royalty') {
    addressType =
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='flexRow justifyContentSpaceAround marginSide0p5 marginTop0p5'>
          <button className={'box3 focusEffect01 riseOut2 ' + (state.getHistory.addressType === 'addressOwner' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
            onClick={ () => {
              dispatch({type: 'setStateMultiLayers', keys: ['getHistory', 'addressType'], value: 'addressOwner'});
            }}>
            {words.addressOwner[state.language]}
          </button>
          <button className={'box3 focusEffect01 riseOut2 ' + (state.getHistory.addressType === 'addressPayRoyaltyTo' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
            onClick={ () => {
                dispatch({type: 'setStateMultiLayers', keys: ['getHistory', 'addressType'], value: 'addressPayRoyaltyTo'});
            }}>
            {words.addressPayRoyaltyTo[state.language]}
          </button>
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='flexColumn alignItemsCenter '>
          <button className={'box3Sp marginTopBottom0p5 focusEffect01 riseOut2 ' + (state.getHistory.addressType === 'addressOwner' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
            onClick={ () => {
              dispatch({type: 'setStateMultiLayers', keys: ['getHistory', 'addressType'], value: 'addressOwner'});
            }}>
            {words.addressOwner[state.language]}
          </button>
          <button className={'box3Sp marginTopBottom0p5 focusEffect01 riseOut2 ' + (state.getHistory.addressType === 'addressPayRoyaltyTo' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
            onClick={ () => {
                dispatch({type: 'setStateMultiLayers', keys: ['getHistory', 'addressType'], value: 'addressPayRoyaltyTo'});
            }}>
            {words.addressPayRoyaltyTo[state.language]}
          </button>
        </div>
      </div>
    </div>;
  }
  else {
    addressType = null;
  }

  // addressFace

  if (state.getHistory.action === 'royalty') {
    if (state.getHistory.addressType === 'addressOwner') {
      addressFace = words.addressOwner[state.language];
    }
    else { // addressPayRoyaltyTo
      addressFace = words.addressPayRoyaltyTo[state.language];
    }
  }
  else {
    addressFace = words.addressMain[state.language];
  }

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <Header screen='history' />
        <div>
          <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
            {/* action */}
            <div className='flexRow justifyContentSpaceAround marginSide0p5 marginTop0p5'>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.getHistory.action === 'exhibit' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['getHistory', 'action'], value: 'exhibit'});
                }}>
                {words.exhibitHistory[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.getHistory.action === 'purchase' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['getHistory', 'action'], value: 'purchase'});
                }}>
                {words.purchaseHistory[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.getHistory.action === 'sales' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['getHistory', 'action'], value: 'sales'});
                }}>
                {words.salesHistory[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.getHistory.action === 'royalty' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                    dispatch({type: 'setStateMultiLayers', keys: ['getHistory', 'action'], value: 'royalty'});
                }}>
                {words.royaltyHistory[state.language]}
              </button>
            </div>
            { addressType }
            {/* address */}
            <TextLine3 fieldName='historyAddressMain' keys={['getHistory', 'addressMain']} face={addressFace} tooltip={true}
              extraFunctionOnChange={ [
                {
                  function: () => {
                    dispatch({
                      type: 'setStateMultiLayers',
                      keys: ['getHistory', 'pagingIndex'],
                      value: { exhibit: 0, purchase: 0, sales: 0, royaltyAddressOwner: 0, royaltyAddressPayRoyaltyTo: 0 }
                    });
                    dispatch({
                      type: 'setStateMultiLayers',
                      keys: ['getHistory', 'lastEvaluatedKey'],
                      value: { exhibit: [], purchase: [], sales: [], royaltyAddressOwner: [], royaltyAddressPayRoyaltyTo: [] }
                    });
                  },
                  arguments: [],
                }
              ]}
            />
            <SelectSessionButton
              stateKeysToSetAddress={[['getHistory', 'addressMain']]}
              stateKeysToSetUserName={[]}
              extraFunction={ () => {
                dispatch({
                  type: 'setStateMultiLayers',
                  keys: ['getHistory', 'pagingIndex'],
                  value: { exhibit: 0, purchase: 0, sales: 0, royaltyAddressOwner: 0, royaltyAddressPayRoyaltyTo: 0 }
                });
                dispatch({
                  type: 'setStateMultiLayers',
                  keys: ['getHistory', 'lastEvaluatedKey'],
                  value: { exhibit: [], purchase: [], sales: [], royaltyAddressOwner: [], royaltyAddressPayRoyaltyTo: [] }
                });
              }}
            />
            <button className='button1'
              onClick={ () => {
                handleClickMpurse(state, dispatch, ['getHistory', 'addressMain']);
                dispatch({
                  type: 'setStateMultiLayers',
                  keys: ['getHistory', 'pagingIndex'],
                  value: { exhibit: 0, purchase: 0, sales: 0, royaltyAddressOwner: 0, royaltyAddressPayRoyaltyTo: 0 }
                });
                dispatch({
                  type: 'setStateMultiLayers',
                  keys: ['getHistory', 'lastEvaluatedKey'],
                  value: { exhibit: [], purchase: [], sales: [], royaltyAddressOwner: [], royaltyAddressPayRoyaltyTo: [] }
                });
              }}
            >
              <img className='size2x2' src={iconMpurse} alt='mpurse' />
            </button>
            <button className='button1'
              onClick={ () => {
                handleClickAddressHistory(state, dispatch, cookies, ['getHistory', 'addressMain']);
                dispatch({
                  type: 'setStateMultiLayers',
                  keys: ['getHistory', 'pagingIndex'],
                  value: { exhibit: 0, purchase: 0, sales: 0, royaltyAddressOwner: 0, royaltyAddressPayRoyaltyTo: 0 }
                });
                dispatch({
                  type: 'setStateMultiLayers',
                  keys: ['getHistory', 'lastEvaluatedKey'],
                  value: { exhibit: [], purchase: [], sales: [], royaltyAddressOwner: [], royaltyAddressPayRoyaltyTo: [] }
                });
              }}
            >
              <img className='size2x2' src={iconList} alt='list' />
            </button>
            <button className='button1' tabindex='0' onClick={ () => { historyFunction(0) } }>
              <img className='size2x2' src={iconSearch} alt='search' />
            </button>
            { arrowLeft }
            { arrowRight }
          </div>
        </div>
        { historyItems }
        {/* development */}
        <div>
          { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <Header screen='history' />
        <div className='flexColumn alignItemsCenter marginTop1 '>
          {/* action */}
          <div className='flexColumn alignItemsCenter marginTopBottom0p5'>
            <button className={'box3Sp marginTopBottom0p5 focusEffect01 riseOut2 ' + (state.getHistory.action === 'exhibit' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
              onClick={ () => {
                        dispatch({type: 'setStateMultiLayers', keys: ['getHistory', 'action'], value: 'exhibit'});
              }}>
              {words.exhibitHistory[state.language]}
            </button>
            <button className={'box3Sp marginTopBottom0p5 focusEffect01 riseOut2 ' + (state.getHistory.action === 'purchase' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
              onClick={ () => {
                        dispatch({type: 'setStateMultiLayers', keys: ['getHistory', 'action'], value: 'purchase'});
              }}>
              {words.purchaseHistory[state.language]}
            </button>
            <button className={'box3Sp marginTopBottom0p5 focusEffect01 riseOut2 ' + (state.getHistory.action === 'sales' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
              onClick={ () => {
                        dispatch({type: 'setStateMultiLayers', keys: ['getHistory', 'action'], value: 'sales'});
              }}>
              {words.salesHistory[state.language]}
            </button>
            <button className={'box3Sp marginTopBottom0p5 focusEffect01 riseOut2 ' + (state.getHistory.action === 'royalty' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
              onClick={ () => {
                  dispatch({type: 'setStateMultiLayers', keys: ['getHistory', 'action'], value: 'royalty'});
              }}>
              {words.royaltyHistory[state.language]}
            </button>
          </div>
          { addressType }
          {/* address */}
          <div className='flexColumn '>
            <TextLine3 fieldName='historyAddressMain' keys={['getHistory', 'addressMain']} face={addressFace} tooltip={true}
              extraFunctionOnChange={ [
                {
                  function: () => {
                    dispatch({
                      type: 'setStateMultiLayers',
                      keys: ['getHistory', 'pagingIndex'],
                      value: { exhibit: 0, purchase: 0, sales: 0, royaltyAddressOwner: 0, royaltyAddressPayRoyaltyTo: 0 }
                    });
                    dispatch({
                      type: 'setStateMultiLayers',
                      keys: ['getHistory', 'lastEvaluatedKey'],
                      value: { exhibit: [], purchase: [], sales: [], royaltyAddressOwner: [], royaltyAddressPayRoyaltyTo: [] }
                    });
                  },
                  arguments: [],
                }
              ]}
            />
            <div className='flexRow justifyContentFlexStart marginTopBottom0p5'>
              <SelectSessionButton
                stateKeysToSetAddress={[['getHistory', 'addressMain']]}
                stateKeysToSetUserName={[]}
                extraFunction={ () => {
                  dispatch({
                    type: 'setStateMultiLayers',
                    keys: ['getHistory', 'pagingIndex'],
                    value: { exhibit: 0, purchase: 0, sales: 0, royaltyAddressOwner: 0, royaltyAddressPayRoyaltyTo: 0 }
                  });
                  dispatch({
                    type: 'setStateMultiLayers',
                    keys: ['getHistory', 'lastEvaluatedKey'],
                    value: { exhibit: [], purchase: [], sales: [], royaltyAddressOwner: [], royaltyAddressPayRoyaltyTo: [] }
                  });
                }}
              />
              <button className='button1'
                onClick={ () => {
                  handleClickMpurse(state, dispatch, ['getHistory', 'addressMain']);
                  dispatch({
                    type: 'setStateMultiLayers',
                    keys: ['getHistory', 'pagingIndex'],
                    value: { exhibit: 0, purchase: 0, sales: 0, royaltyAddressOwner: 0, royaltyAddressPayRoyaltyTo: 0 }
                  });
                  dispatch({
                    type: 'setStateMultiLayers',
                    keys: ['getHistory', 'lastEvaluatedKey'],
                    value: { exhibit: [], purchase: [], sales: [], royaltyAddressOwner: [], royaltyAddressPayRoyaltyTo: [] }
                  });
                }}
              >
                <img className='size2x2' src={iconMpurse} alt='mpurse' />
              </button>
              <button className='button1'
                onClick={ () => {
                  handleClickAddressHistory(state, dispatch, cookies, ['getHistory', 'addressMain']);
                  dispatch({
                    type: 'setStateMultiLayers',
                    keys: ['getHistory', 'pagingIndex'],
                    value: { exhibit: 0, purchase: 0, sales: 0, royaltyAddressOwner: 0, royaltyAddressPayRoyaltyTo: 0 }
                  });
                  dispatch({
                    type: 'setStateMultiLayers',
                    keys: ['getHistory', 'lastEvaluatedKey'],
                    value: { exhibit: [], purchase: [], sales: [], royaltyAddressOwner: [], royaltyAddressPayRoyaltyTo: [] }
                  });
                }}
              >
                <img className='size2x2' src={iconList} alt='list' />
              </button>
              <button className='button1' tabindex='0' onClick={ () => { historyFunction(0) } }>
                <img className='size2x2' src={iconSearch} alt='search' />
              </button>
            </div>
          </div>
          <div className='flexRow justifyContentFlexStart marginTopBottom0p5'>
            <div className='marginSide1'>
              { arrowLeft }
            </div>
            <div className='marginSide1'>
              { arrowRight }
            </div>
          </div>
        </div>
        { historyItems }
      </div>
    </div>
  );
}

// EXHIBIT RECORD TITLE
function ExhibitRecordTitle() {
  const state = useGlobalStateSelector( ({ state }) => state );

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { words.exhibitNo[state.language] }
          </div>
          <div className='marginSide1 widthMin25' >
            { words.tokenName[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.unitPriceMona[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.amountFree[state.language] + ' / ' + words.amountToSellWhole[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.status[state.language] }
          </div>
          <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite' disabled={true} />
        </div>
      </div>
      {/* SP */}
    </div>
  );
}

// EXHIBIT RECORD
function ExhibitRecord(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );

  const record = props.record;
  const assetCommon = props.record.asset_longname === null ? props.record.asset : props.record.asset_longname;

  let buttons;
  let popup;

  if (record.status === 'waitingForSignature') {
    popup = { type: 'exhibitRecordDetailResume', body: props.record };
    buttons =
      <button className='button1' onClick={ () => { dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup }) } } >
        <img className='size2x2' src={iconDetail} alt='detail' />
      </button>;
  }
  else if (record.status === 'waitingForToken') {
    popup = { type: 'exhibitRecordDetailResume', body: props.record };
    buttons =
      <button className='button1' onClick={ () => { dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup }) } } >
        <img className='size2x2' src={iconDetail} alt='detail' />
      </button>;
  }
  else if (record.status === 'onSale' && record.amountFree >= 1) {
    popup = { type: 'exhibitRecordDetailChange', body: props.record };
    buttons =
      <button className='button1' onClick={ () => { dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup }) } } >
        <img className='size2x2' src={iconDetail} alt='detail' />
      </button>;
  }
  else {
    popup = { type: 'exhibitRecordDetailFinished', body: props.record };
    buttons =
      <button className='button1' onClick={ () => { dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup }) } } >
        <img className='size2x2' src={iconDetail} alt='detail' />
      </button>;
  }

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { 'No. ' + props.record.exhibitNo }
          </div>
          <div className='marginSide1 widthMin25' >
            { assetCommon }
          </div>
          <div className='marginSide1 widthMin15' >
            { props.record.priceMona + ' MONA' }
          </div>
          <div className='marginSide1 widthMin15' >
            { props.record.amountFree + ' / ' + props.record.amountToSell }
          </div>
          <div className='marginSide1 widthMin15' >
            { words[props.record.status][state.language] }
          </div>
          { buttons }
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='boxMonacotto1SmallScreen flexColumn alignItemsFlexStart '  >
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.exhibitNo[state.language] }
            </div>
            <div className='flexRow alignItemsCenter' >
              <div>
                { 'No. ' + props.record.exhibitNo }
              </div>
              { buttons }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween width98PC'>
            <div className='' >
              { words.tokenName[state.language] }
            </div>
            <div className='breakAll' >
              { assetCommon }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween width98PC'>
            <div className='' >
              { words.unitPriceMona[state.language] }
            </div>
            <div className='' >
              { props.record.priceMona + ' MONA' }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween width98PC'>
            <div className='' >
              { words.amountFree[state.language] + ' / ' + words.amountToSellWhole[state.language] }
            </div>
            <div className='' >
              { props.record.amountFree + ' / ' + props.record.amountToSell }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween width98PC'>
            <div className='' >
              { words.status[state.language] }
            </div>
            <div className='' >
              { words[props.record.status][state.language] }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// EXHIBIT RECORD DETAIL RESUME
function ExhibitRecordDetailResume(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const cookies = useGlobalStateSelector( ({ cookies }) => cookies );
  const setCookie = useGlobalStateSelector( ({ setCookie }) => setCookie );
  const popupLayer = props.popupLayer;
  const record = state.popup[props.popupLayer].body;

  useEffect( () => {
    // state.exhibitに値を格納する。
    const exhibit = {
      exhibitNo: record.exhibitNo,
      addressMain: record.addressMain,
      addressCardFrom: record.addressCardFrom,
      addressPayProceedsTo: record.addressPayProceedsTo,
      monacottoAddressMonaparty: record.monacottoAddressMonaparty,
      tokenName: record.tokenName,
      amountToSell: record.amountToSell,
      priceMona: { face: record.priceMona, value: record.priceMona },
      priceMonaWatanabe: record.priceMonaWatanabe,
      signatureByAddressMain: record.signatureByAddressMain,
      signatureByAddressCardFrom: record.signatureByAddressCardFrom,
      status: record.status,
    };

    dispatch({ type: 'setState', key: 'exhibit', value: exhibit });
  }, []);

  const onClickSignExhibit = async () => {
    const result = await handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressCardFrom');

    if (result.status === 'fulfilled') {
      const activeCertification = buildActiveCertification(result, 'exhibit', ['addressMain', 'addressMainActual', 'addressCardFrom', 'addressCardFromActual']);
      handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, activeCertification);
    }
    else if (result?.message === 'nfcRequired') {
      const callback = async (keyPairs) => {
        const result = await handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressCardFrom', keyPairs);
        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

        if (result.status === 'fulfilled') {
          const activeCertification = buildActiveCertification(result, 'exhibit', ['addressMain', 'addressMainActual', 'addressCardFrom', 'addressCardFromActual']);
          handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, activeCertification);
        }
      };

      handleClickNfc(state, dispatch, callback);
    }
    else if (result?.message === 'nfcNativeRequired') {
      const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, popupLayer, language: state.language, network: state.networkMona });

      const resultWithKeyPairs = await handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressCardFrom', keyPairs);
      keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

      if (resultWithKeyPairs.status === 'fulfilled') {
        const activeCertification = buildActiveCertification(resultWithKeyPairs, 'exhibit', ['addressMain', 'addressMainActual', 'addressCardFrom', 'addressCardFromActual']);
        handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, activeCertification);
      }
    }
    else if (result?.message === 'bcRequired') {
      const callback = async (keyPairs) => {
        const result = await handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressCardFrom', keyPairs);
        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

        if (result.status === 'fulfilled') {
          const activeCertification = buildActiveCertification(result, 'exhibit', ['addressMain', 'addressMainActual', 'addressCardFrom', 'addressCardFromActual']);
          handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, activeCertification);
        }
      };

      handleClickScanQr(state, dispatch, callback, { popupLayer: popupLayer + 1 });
    }
  };


  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        {/* exhibit */}
        <div className='flexRow justifyContentCenter'>
          {
            ((state.exhibit.signatureByAddressCardFrom === undefined ||
              state.exhibit.signatureByAddressCardFrom === null ||
              state.exhibit.signatureByAddressCardFrom === '') &&
             (state.exhibit.exhibitNo !== undefined &&
              state.exhibit.exhibitNo !== null &&
              state.exhibit.exhibitNo !== '')) ?
              <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0' onClick={ onClickSignExhibit } >
                <div>
                  {words.signByAddressYouSendCardsFrom[state.language]}
                </div>
                <img className='size2x2' src={iconSign} alt='sign' />
              </button>
            : null
          }
        </div>
        <ResumeExhibit record={record} popupLayer={popupLayer} />
        <div className='flexColumn'>
          <div className='flexColumn boxDetail'>
            <div>
              {words.addressMain[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.addressMain}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.exhibitNo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.exhibitNo}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.asset[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.asset_longname[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset_longname}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.addressOwner[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.addressOwner}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.ownerName[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.ownerName}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.addressPayRoyaltyTo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.addressPayRoyaltyTo}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.royaltyRecipientName[state.language]}
            </div>
            <div className='paddingLeft1'>
              { state.usersGeneralIndex[record.addressPayRoyaltyTo] !== undefined ? state.usersGeneralIndex[record.addressPayRoyaltyTo].userName : null }
            </div>
          </div>
          <div className='flexRow boxDetail justifyContentSpaceBetween'>
            <div className='flexColumn '>
              <div>
                {words.addressCardFrom[state.language]}
              </div>
              <div className='paddingLeft1'>
                {record.addressCardFrom}
              </div>
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.addressPayProceedsTo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.addressPayProceedsTo}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.unitPriceMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.priceMona + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.exhibitorProceedsNetMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.proceedsNetMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.royaltyMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.royaltyMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.feeExhibitMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.feeExhibitMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.feePurchaseMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.feePurchaseMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.amountToSellWhole[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.amountToSell}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.amountFree[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.amountFree}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.status[state.language]}
            </div>
            <div className='paddingLeft1'>
              {words[record.status][state.language]}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.applicationTimeOfExhibit[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.serverTimeOfAddressMain)}
            </div>
          </div>
          {
            record.status === 'waitingForSignature' ?
            <div className='flexColumn boxDetail'>
              <div>
                {words.deadlineOfTheSecondSignature[state.language]}
              </div>
              <div className='paddingLeft1'>
                {localTime(record.serverTimeOfAddressMain + state.config.clientParameters.exhibitSecondSignatureExpirationTime)}
              </div>
            </div>
            : null
          }
          {
            record.status === 'waitingForToken' ?
            <div className='flexColumn boxDetail'>
              <div>
                {words.deadlineOfSendingCards[state.language]}
              </div>
              <div className='paddingLeft1'>
                {localTime(record.serverTimeOfAddressCardFrom + state.config.clientParameters.exhibitExpirationTime)}
              </div>
            </div>
            : null
          }
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        {/* exhibit */}
        <div className='flexRow justifyContentCenter'>
          {
            ((state.exhibit.signatureByAddressCardFrom === undefined ||
              state.exhibit.signatureByAddressCardFrom === null ||
              state.exhibit.signatureByAddressCardFrom === '') &&
             (state.exhibit.exhibitNo !== undefined &&
              state.exhibit.exhibitNo !== null &&
              state.exhibit.exhibitNo !== '')) ?
              <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'onClick={ onClickSignExhibit } >
                <div>
                  {words.signByAddressYouSendCardsFrom[state.language]}
                </div>
                <img className='size2x2' src={iconSign} alt='sign' />
              </button>
            : null
          }
        </div>
        <ResumeExhibit record={record} popupLayer={popupLayer} />
        {/* detail */}
        <div className='flexColumn alignItemsCenter'>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressMain[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressMain}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitNo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.exhibitNo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.asset[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.asset_longname[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset_longname}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressOwner[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressOwner}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.ownerName[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.ownerName}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressPayRoyaltyTo[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressPayRoyaltyTo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.royaltyRecipientName[state.language]}
            </div>
            <div className='paddingLeft1'>
              { state.usersGeneralIndex[record.addressPayRoyaltyTo] !== undefined ? state.usersGeneralIndex[record.addressPayRoyaltyTo].userName : null }
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressCardFrom[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressCardFrom}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressPayProceedsTo[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressPayProceedsTo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.unitPriceMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.priceMona + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitorProceedsNetMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.proceedsNetMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.royaltyMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.royaltyMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.feeExhibitMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.feeExhibitMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.feePurchaseMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.feePurchaseMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.amountToSellWhole[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.amountToSell}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.amountFree[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.amountFree}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.status[state.language]}
            </div>
            <div className='paddingLeft1'>
              {words[record.status][state.language]}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.applicationTimeOfExhibit[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.serverTimeOfAddressMain)}
            </div>
          </div>
          {
            record.status === 'waitingForSignature' ?
            <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
              <div className='width96PC '>
                {words.deadlineOfTheSecondSignature[state.language]}
              </div>
              <div className='paddingLeft1'>
                {localTime(record.serverTimeOfAddressMain + state.config.clientParameters.exhibitSecondSignatureExpirationTime)}
              </div>
            </div>
            : null
          }
          {
            record.status === 'waitingForToken' ?
            <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
              <div className='width96PC '>
                {words.deadlineOfSendingCards[state.language]}
              </div>
              <div className='paddingLeft1'>
                {localTime(record.serverTimeOfAddressCardFrom + state.config.clientParameters.exhibitExpirationTime)}
              </div>
            </div>
            : null
          }
        </div>
      </div>
    </div>
  );
                // onClick={ async () => {
                //   const result = await handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressCardFrom');

                //   if (result.status === 'fulfilled') {
                //     // handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0);
                //     const { body: { sessionId, expirationOfSession, exhibit }} = result;
                //     const activeCertification = [];

                //     if (sessionId.addressMain !== undefined) {
                //       activeCertification.push({ address: exhibit.addressMain, sessionId: sessionId.addressMain, expirationOfSession: expirationOfSession.addressMain });
                //     }

                //     if (sessionId.addressMainActual !== undefined) {
                //       activeCertification.push({ address: exhibit.addressMainActual, sessionId: sessionId.addressMainActual, expirationOfSession: expirationOfSession.addressMainActual });
                //     }

                //     if (sessionId.addressCardFrom !== undefined) {
                //       activeCertification.push({ address: exhibit.addressCardFrom, sessionId: sessionId.addressCardFrom, expirationOfSession: expirationOfSession.addressCardFrom });
                //     }

                //     if (sessionId.addressCardFromActual !== undefined) {
                //       activeCertification.push({ address: exhibit.addressCardFromActual, sessionId: sessionId.addressCardFromActual, expirationOfSession: expirationOfSession.addressCardFromActual });
                //     }

                //     handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, activeCertification);
                //   }
                // }}

                // onClick={ async () => {
                //   const result = await handleClickSignExhibit(state, dispatch, cookies, setCookie, 'addressCardFrom');

                //   if (result.status === 'fulfilled') {
                //     handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0);
                //   }
                // }}
}

// EXHIBIT RECORD DETAIL CHANGE
function ExhibitRecordDetailChange(props) {
  const popupLayer = props.popupLayer;
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const record = state.popup[props.popupLayer].body;

  useEffect( () => {
    // state.changeExhibitに値を格納する。
    const changeExhibit = {
      exhibitNo: record.exhibitNo,
      addressMain: record.addressMain,
      addressPayProceedsTo: record.addressPayProceedsTo,
      priceMona: { face: record.priceMona, value: record.priceMona },
      tokenName: record.tokenName, // ← addressHistoryで使う。
      amountToSell: record.amountToSell, // ← addressHistoryで使う。
      signatureByAddressMainChange: null,
      status: 'waitingForSignature', // ← onSaleにしたいという気持ちがある。
    };

    dispatch({ type: 'setState', key: 'changeExhibit', value: changeExhibit });

    // state.cancelExhibitに値を格納する。
    const cancelExhibit = {
      exhibitNo: record.exhibitNo,
      addressMain: record.addressMain,
      tokenName: record.tokenName, // ← addressHistoryで使う。
      amountToSell: record.amountToSell, // ← addressHistoryで使う。
      signatureByAddressMainCancel: null,
      status: 'waitingForSignature', // ← onSaleにしたいという気持ちがある。
    };

    dispatch({ type: 'setState', key: 'cancelExhibit', value: cancelExhibit });
  }, []);

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        {/* cancel action */}
        <div className='flexRow justifyContentSpaceAround marginSide0p5 marginTop0p5'>
          <button className={'box3 focusEffect01 riseOut2 ' + (state.getHistory.cancelAction === 'cancel' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
            onClick={ () => {
                      dispatch({type: 'setStateMultiLayers', keys: ['getHistory', 'cancelAction'], value: 'cancel'});
            }}>
            {words.cancel[state.language]}
          </button>
          <button className={'box3 focusEffect01 riseOut2 ' + (state.getHistory.cancelAction === 'change' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
            onClick={ () => {
                      dispatch({type: 'setStateMultiLayers', keys: ['getHistory', 'cancelAction'], value: 'change'});
            }}>
            {words.cancelAndReexhibit[state.language]}
          </button>
        </div>
        {/* exhibit */}
        <div className='flexRow justifyContentCenter'>
          { state.getHistory.cancelAction === 'change' ? <ChangeExhibit popupLayer={popupLayer} /> : null }
        </div>
        <div>
          { state.getHistory.cancelAction === 'cancel' ? <CancelSigning popupLayer={props.popupLayer} /> : <ChangeExhibitSigning popupLayer={props.popupLayer} /> }
        </div>
        <div className='flexColumn'>
          <div className='flexRow boxDetail justifyContentSpaceBetween'>
            <div className='flexColumn '>
              <div>
                {words.addressMain[state.language]}
              </div>
              <div className='paddingLeft1'>
                {record.addressMain}
              </div>
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.exhibitNo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.exhibitNo}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.asset[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.asset_longname[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset_longname}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.addressOwner[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.addressOwner}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.ownerName[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.ownerName}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.addressPayRoyaltyTo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.addressPayRoyaltyTo}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.royaltyRecipientName[state.language]}
            </div>
            <div className='paddingLeft1'>
              { state.usersGeneralIndex[record.addressPayRoyaltyTo] !== undefined ? state.usersGeneralIndex[record.addressPayRoyaltyTo].userName : null }
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.addressCardFrom[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.addressCardFrom}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.addressPayProceedsTo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.addressPayProceedsTo}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.unitPriceMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.priceMona + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.exhibitorProceedsNetMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.proceedsNetMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.royaltyMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.royaltyMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.feeExhibitMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.feeExhibitMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.feePurchaseMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.feePurchaseMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.amountToSellWhole[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.amountToSell}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.amountFree[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.amountFree}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.status[state.language]}
            </div>
            <div className='paddingLeft1'>
              {words[record.status][state.language]}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.txidOfSendingCards[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.receiveTokenTx_hash}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.msg_indexOfSendingCards[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.receiveTokenMsg_index}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.exhibitNoToBeTakenOver[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.exhibitNoToBeTakenOver}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.exhibitNoToTakeOver[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.exhibitNoToTakeOver}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.applicationTimeOfExhibit[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.serverTimeOfAddressMain)}
            </div>
          </div>
          <div className='margin1'>
            当出品に紐づく購入履歴も表示する予定です。
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        {/* cancel action */}
        <div className='flexRow justifyContentSpaceAround marginSide0p5 marginTop0p5'>
          <button className={'box3 focusEffect01 riseOut2 ' + (state.getHistory.cancelAction === 'cancel' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
            onClick={ () => {
                      dispatch({type: 'setStateMultiLayers', keys: ['getHistory', 'cancelAction'], value: 'cancel'});
            }}>
            {words.cancel[state.language]}
          </button>
          <button className={'box3 focusEffect01 riseOut2 ' + (state.getHistory.cancelAction === 'change' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
            onClick={ () => {
                      dispatch({type: 'setStateMultiLayers', keys: ['getHistory', 'cancelAction'], value: 'change'});
            }}>
            {words.cancelAndReexhibit[state.language]}
          </button>
        </div>
        {/* exhibit */}
        <div className='flexColumn alignItemsCenter'>
          <div className=''>
            { state.getHistory.cancelAction === 'change' ? <ChangeExhibit popupLayer={popupLayer} /> : null }
          </div>
          <div>
            { state.getHistory.cancelAction === 'cancel' ? <CancelSigning popupLayer={props.popupLayer} /> : <ChangeExhibitSigning popupLayer={props.popupLayer} /> }
          </div>
        </div>
        {/* detail */}
        <div className='flexColumn alignItemsCenter'>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressMain[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressMain}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitNo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.exhibitNo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.asset[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.asset_longname[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset_longname}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressOwner[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressOwner}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.ownerName[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.ownerName}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressPayRoyaltyTo[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressPayRoyaltyTo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.royaltyRecipientName[state.language]}
            </div>
            <div className='paddingLeft1'>
              { state.usersGeneralIndex[record.addressPayRoyaltyTo] !== undefined ? state.usersGeneralIndex[record.addressPayRoyaltyTo].userName : null }
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressCardFrom[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressCardFrom}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressPayProceedsTo[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressPayProceedsTo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.unitPriceMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.priceMona + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitorProceedsNetMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.proceedsNetMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.royaltyMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.royaltyMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.feeExhibitMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.feeExhibitMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.feePurchaseMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.feePurchaseMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.amountToSellWhole[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.amountToSell}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.amountFree[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.amountFree}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.status[state.language]}
            </div>
            <div className='paddingLeft1'>
              {words[record.status][state.language]}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.txidOfSendingCards[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.receiveTokenTx_hash}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.msg_indexOfSendingCards[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.receiveTokenMsg_index}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitNoToBeTakenOver[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.exhibitNoToBeTakenOver}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitNoToTakeOver[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.exhibitNoToTakeOver}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.applicationTimeOfExhibit[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.serverTimeOfAddressMain)}
            </div>
          </div>
          <div className='margin1'>
            当出品に紐づく購入履歴も表示する予定です。
          </div>
        </div>
      </div>
    </div>
  );
}

// EXHIBIT RECORD DETAIL FINISHED
function ExhibitRecordDetailFinished(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const record = state.popup[props.popupLayer].body;

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='flexColumn'>
          <div className='flexColumn boxDetail'>
            <div>
              {words.addressMain[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.addressMain}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.exhibitNo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.exhibitNo}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.asset[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.asset_longname[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset_longname}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.addressOwner[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.addressOwner}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.ownerName[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.ownerName}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.addressPayRoyaltyTo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.addressPayRoyaltyTo}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.royaltyRecipientName[state.language]}
            </div>
            <div className='paddingLeft1'>
              { state.usersGeneralIndex[record.addressPayRoyaltyTo] !== undefined ? state.usersGeneralIndex[record.addressPayRoyaltyTo].userName : null }
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.addressCardFrom[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.addressCardFrom}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.addressPayProceedsTo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.addressPayProceedsTo}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.unitPriceMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.priceMona + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.exhibitorProceedsNetMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.proceedsNetMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.royaltyMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.royaltyMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.feeExhibitMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.feeExhibitMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.feePurchaseMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.feePurchaseMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.amountToSellWhole[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.amountToSell}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.amountFree[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.amountFree}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.status[state.language]}
            </div>
            <div className='paddingLeft1'>
              {words[record.status][state.language]}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.txidOfSendingCards[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.receiveTokenTx_hash}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.msg_indexOfSendingCards[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.receiveTokenMsg_index}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.txidOfSendingBackCards[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.sendBackTokenTxid}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.exhibitNoToBeTakenOver[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.exhibitNoToBeTakenOver}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.exhibitNoToTakeOver[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.exhibitNoToTakeOver}
            </div>
          </div>
          <div className='flexColumn boxDetail'>
            <div>
              {words.applicationTimeOfExhibit[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.serverTimeOfAddressMain)}
            </div>
          </div>
          {
            record.status === 'expiredWithoutSecondSignature' ?
            <div className='flexColumn boxDetail'>
              <div>
                {words.deadlineOfTheSecondSignature[state.language]}
              </div>
              <div className='paddingLeft1'>
                {localTime(record.serverTimeOfAddressMain + state.config.clientParameters.exhibitSecondSignatureExpirationTime)}
              </div>
            </div>
            : null
          }
          {
            record.status === 'expired' ?
            <div className='flexColumn boxDetail'>
              <div>
                {words.deadlineOfSendingCards[state.language]}
              </div>
              <div className='paddingLeft1'>
                {localTime(record.serverTimeOfAddressCardFrom + state.config.clientParameters.exhibitExpirationTime)}
              </div>
            </div>
            : null
          }
          <div className='margin1'>
            当出品に紐づく購入履歴も表示する予定です。
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='flexColumn alignItemsCenter'>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressMain[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressMain}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitNo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.exhibitNo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.asset[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.asset_longname[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset_longname}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressOwner[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressOwner}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.ownerName[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.ownerName}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressPayRoyaltyTo[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressPayRoyaltyTo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.royaltyRecipientName[state.language]}
            </div>
            <div className='paddingLeft1'>
              { state.usersGeneralIndex[record.addressPayRoyaltyTo] !== undefined ? state.usersGeneralIndex[record.addressPayRoyaltyTo].userName : null }
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressCardFrom[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressCardFrom}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressPayProceedsTo[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressPayProceedsTo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.unitPriceMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.priceMona + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitorProceedsNetMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.proceedsNetMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.royaltyMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.royaltyMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.feeExhibitMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.feeExhibitMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.feePurchaseMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.feePurchaseMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.amountToSellWhole[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.amountToSell}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.amountFree[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.amountFree}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.status[state.language]}
            </div>
            <div className='paddingLeft1'>
              {words[record.status][state.language]}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.txidOfSendingCards[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.receiveTokenTx_hash}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.msg_indexOfSendingCards[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.receiveTokenMsg_index}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.txidOfSendingBackCards[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.sendBackTokenTxid}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitNoToBeTakenOver[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.exhibitNoToBeTakenOver}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitNoToTakeOver[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.exhibitNoToTakeOver}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.applicationTimeOfExhibit[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.serverTimeOfAddressMain)}
            </div>
          </div>
          {
            record.status === 'expiredWithoutSecondSignature' ?
            <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
              <div className='width96PC '>
                {words.deadlineOfTheSecondSignature[state.language]}
              </div>
              <div className='paddingLeft1'>
                {localTime(record.serverTimeOfAddressMain + state.config.clientParameters.exhibitSecondSignatureExpirationTime)}
              </div>
            </div>
            : null
          }
          {
            record.status === 'expired' ?
            <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
              <div className='width96PC '>
                {words.deadlineOfSendingCards[state.language]}
              </div>
              <div className='paddingLeft1'>
                {localTime(record.serverTimeOfAddressCardFrom + state.config.clientParameters.exhibitExpirationTime)}
              </div>
            </div>
            : null
          }
          <div className='margin1'>
            当出品に紐づく購入履歴も表示する予定です。
          </div>
        </div>
      </div>
    </div>
  );
}

// PURCHASE RECORD TITLE
function PurchaseRecordTitle(props) {
  const state = useGlobalStateSelector( ({ state }) => state );

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { words.purchaseNo[state.language] }
          </div>
          <div className='marginSide1 widthMin25' >
            { words.tokenName[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.unitPriceMona[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.amountToBuy[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.status[state.language] }
          </div>
          <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite' disabled={true} />
        </div>
      </div>
      {/* SP */}
    </div>
  );
}

// PURCHASE RECORD
function PurchaseRecord(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const record = props.record;
  const assetCommon = record.asset_longname === null ? record.asset : record.asset_longname;

  let buttons;
  let popup;

  if (record.status === 'waitingForSignature') {
    popup = { type: 'purchaseRecordDetail', body: props.record };
    buttons =
      <button className='button1' onClick={ () => { dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup }) } } >
        <img className='size2x2' src={iconDetail} alt='detail' />
      </button>;
  }
  else if (record.status === 'waitingForMona') {
    popup = { type: 'purchaseRecordDetail', body: props.record };
    buttons =
      <button className='button1' onClick={ () => { dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup }) } } >
        <img className='size2x2' src={iconDetail} alt='detail' />
      </button>;
  }
  else {
    // buttons = <div className='width2p4' />
    popup = { type: 'purchaseRecordDetail', body: props.record };
    buttons =
      <button className='button1' onClick={ () => { dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup }) } } >
        <img className='size2x2' src={iconDetail} alt='detail' />
      </button>;
  }

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { 'No. ' + props.record.purchaseNo }
          </div>
          <div className='marginSide1 widthMin25' >
            { assetCommon }
          </div>
          <div className='marginSide1 widthMin15' >
            { props.record.priceMona + ' MONA' }
          </div>
          <div className='marginSide1 widthMin15' >
            { props.record.amountToBuy }
          </div>
          <div className='marginSide1 widthMin15' >
            { words[props.record.status][state.language] }
          </div>
          { buttons }
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='boxMonacotto1SmallScreen flexColumn alignItemsFlexStart '  >
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.purchaseNo[state.language] }
            </div>
            <div className='flexRow alignItemsCenter' >
              <div>
                { 'No. ' + props.record.purchaseNo }
              </div>
              { buttons }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.tokenName[state.language] }
            </div>
            <div className='' >
              { assetCommon }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.unitPriceMona[state.language] }
            </div>
            <div className='' >
              { props.record.priceMona + ' MONA' }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.amountToBuy[state.language] }
            </div>
            <div className='' >
              { props.record.amountToBuy }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.status[state.language] }
            </div>
            <div className='' >
              { words[props.record.status][state.language] }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// PURCHASE RECORD DETAIL
function PurchaseRecordDetail(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const record = state.popup[props.popupLayer].body;

  useEffect( () => {
    // state.purchaseに値を格納する。 ←　これやんなくてもいいかも。むしろやらないほうがいいかも。
    const purchase = {
      purchaseNo: record.purchaseNo,
      addressMain: record.addressMain,
      addressPayFrom: record.addressPayFrom,
      addressSendCardTo: record.addressSendCardTo,
      addressMainExhibitor: record.addressMainExhibitor,
      exhibitNo: record.exhibitNo,
      amountToBuy: record.amountToBuy,
      signatureByAddressMain: record.signatureByAddressMain,
      signatureByAddressPayFrom: record.signatureByAddressPayFrom,
      addressPayRoyaltyTo: record.addressPayRoyaltyTo,
      status: record.status,
    };

    dispatch({ type: 'setState', key: 'purchase', value: purchase });
  }, []);

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div>
          <ResumePurchaseSigning popupLayer={props.popupLayer} />
        </div>
        <ResumePurchase record={record} popupLayer={props.popupLayer} />
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressMain[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressMain}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.purchaseNo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.purchaseNo}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressMainExhibitor[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressMainExhibitor}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.exhibitorName[state.language]}
          </div>
          <div className='paddingLeft1'>
            {state.usersGeneralIndex[record.addressMainExhibitor] !== undefined ? state.usersGeneralIndex[record.addressMainExhibitor].userName : null}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.exhibitNo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.exhibitNo}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.asset[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.asset}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.asset_longname[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.asset_longname}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressOwner[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressOwner}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.ownerName[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.ownerName}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressPayProceedsTo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressPayProceedsTo}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressPayRoyaltyTo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressPayRoyaltyTo}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.royaltyRecipientName[state.language]}
          </div>
          <div className='paddingLeft1'>
            {state.usersGeneralIndex[record.addressPayRoyaltyTo] !== undefined ? state.usersGeneralIndex[record.addressPayRoyaltyTo].userName : null}
          </div>
        </div>
        <div className='flexRow boxDetail justifyContentSpaceBetween'>
          <div className='flexColumn '>
            <div>
              {words.addressPayFrom[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.addressPayFrom}
            </div>
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressSendCardTo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressSendCardTo}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.unitPriceMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.priceMona + ' MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.exhibitorProceedsNetMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {(record.proceedsNetMona / 100000000) + 'MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.royaltyMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {(record.royaltyMona / 100000000) + ' MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.feeExhibitMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {(record.feeExhibitMona / 100000000) + ' MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.feePurchaseMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {(record.feePurchaseMona / 100000000) + ' MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.amountToBuy[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.amountToBuy}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.status[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[record.status][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.txidOfSendingMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.receiveMonaTxid}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.txidOfSendingCards[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.sendTokenTxid}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.applicationTimeOfPurchase[state.language]}
          </div>
          <div className='paddingLeft1'>
            {localTime(record.serverTimeOfAddressMain)}
          </div>
        </div>
        {
          record.status === 'waitingForSignature' || record.status === 'expiredWithoutSecondSignature' ?
          <div className='flexColumn boxDetail'>
            <div>
              {words.deadlineOfTheSecondSignature[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.serverTimeOfAddressMain + state.config.clientParameters.purchaseSecondSignatureExpirationTime)}
            </div>
          </div>
          : null
        }
        {
          record.status === 'waitingForMona' || record.status === 'expired' ?
          <div className='flexColumn boxDetail'>
            <div>
              {words.deadlineOfSendingMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.serverTimeOfAddressPayFrom + state.config.clientParameters.purchaseExpirationTime)}
            </div>
          </div>
          : null
        }
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div>
          <ResumePurchaseSigning popupLayer={props.popupLayer} />
        </div>
        <ResumePurchase record={record} popupLayer={props.popupLayer} />
        {/* detail */}
        <div className='flexColumn alignItemsCenter'>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressMain[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressMain}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.purchaseNo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.purchaseNo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressMainExhibitor[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressMainExhibitor}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitorName[state.language]}
            </div>
            <div className='paddingLeft1'>
              {state.usersGeneralIndex[record.addressMainExhibitor] !== undefined ? state.usersGeneralIndex[record.addressMainExhibitor].userName : null}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitNo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.exhibitNo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.asset[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.asset_longname[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset_longname}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressOwner[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressOwner}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.ownerName[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.ownerName}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressPayProceedsTo[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressPayProceedsTo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressPayRoyaltyTo[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressPayRoyaltyTo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.royaltyRecipientName[state.language]}
            </div>
            <div className='paddingLeft1'>
              {state.usersGeneralIndex[record.addressPayRoyaltyTo] !== undefined ? state.usersGeneralIndex[record.addressPayRoyaltyTo].userName : null}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressPayFrom[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressPayFrom}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressSendCardTo[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressSendCardTo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.unitPriceMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.priceMona + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitorProceedsNetMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.proceedsNetMona / 100000000) + 'MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.royaltyMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.royaltyMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.feeExhibitMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.feeExhibitMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.feePurchaseMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {(record.feePurchaseMona / 100000000) + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.amountToBuy[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.amountToBuy}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.status[state.language]}
            </div>
            <div className='paddingLeft1'>
              {words[record.status][state.language]}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.txidOfSendingMona[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.receiveMonaTxid}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.txidOfSendingCards[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.sendTokenTxid}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.applicationTimeOfPurchase[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.serverTimeOfAddressMain)}
            </div>
          </div>
          {
            record.status === 'waitingForSignature' || record.status === 'expiredWithoutSecondSignature' ?
            <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
              <div className='width96PC '>
                {words.deadlineOfTheSecondSignature[state.language]}
              </div>
              <div className='paddingLeft1'>
                {localTime(record.serverTimeOfAddressMain + state.config.clientParameters.purchaseSecondSignatureExpirationTime)}
              </div>
            </div>
            : null
          }
          {
            record.status === 'waitingForMona' || record.status === 'expired' ?
            <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
              <div className='width96PC '>
                {words.deadlineOfSendingMona[state.language]}
              </div>
              <div className='paddingLeft1'>
                {localTime(record.serverTimeOfAddressPayFrom + state.config.clientParameters.purchaseExpirationTime)}
              </div>
            </div>
            : null
          }
        </div>
      </div>
    </div>
  );
}

// RESUME PURCHASE
function ResumePurchase(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const cookies = useGlobalStateSelector( ({ cookies }) => cookies );
  const setCookie = useGlobalStateSelector( ({ setCookie }) => setCookie );
  const record = props.record;
  const popupLayer = props.popupLayer;

  const confirmTheDetailsOfSendingMona = <button className='buttonMainColor heightMin3 paddingSide1' tabindex='0'
    onClick={ () => {
      const popup = {
        type: 'sendMonaConfirmation',
        body: {
          addressPayProceedsTo: record.addressPayProceedsTo,
          addressPayRoyaltyTo: record.addressPayRoyaltyTo,
          monacottoAddressMona: state.config.monacottoAddress.monacottoAddressMona,
          proceedsNetMona: record.proceedsNetMona * record.amountToBuy,
          royaltyMona: record.royaltyMona * record.amountToBuy,
          feeMona: record.feeMona * record.amountToBuy,
          transactionFeeUpperBound: state.config.clientParameters.transactionFeeUpperBound,
        },
      };

      dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
    }}
  >
    {words.confirmTheDetailsOfSendingMona[state.language]}
  </button>

  let confirmation;

  if (wallet === 'MonaPallet') {
    confirmation = confirmTheDetailsOfSendingMona;
  }
  else { // Mpurse
    confirmation = null;
  }

  return (
      <div className='flexRow justifyContentCenter'>
        {
          state.purchase.status === 'waitingForMona' && record.sendMonaTxidFromClient === undefined ?
            <div className='flexColumn alignItemsCenter'>
              {/* PC */}
              <div className="visibleMiddleOrMore">
                { confirmation }
              </div>
              {/* SP */}
              <div className="flexColumn alignItemsCenter visibleSmallOrLess ">
                <button className='buttonMainColor heightMin3 paddingSide1' tabindex='0'
                  onClick={ () => {
                    const popup = {
                      type: 'sendMonaConfirmation',
                      body: {
                        addressPayProceedsTo: record.addressPayProceedsTo,
                        addressPayRoyaltyTo: record.addressPayRoyaltyTo,
                        monacottoAddressMona: state.config.monacottoAddress.monacottoAddressMona,
                        proceedsNetMona: record.proceedsNetMona * record.amountToBuy,
                        royaltyMona: record.royaltyMona * record.amountToBuy,
                        feeMona: record.feeMona * record.amountToBuy,
                        transactionFeeUpperBound: state.config.clientParameters.transactionFeeUpperBound,
                      },
                    };

                    dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
                  }}
                >
                  {words.confirmTheDetailsOfSendingMona[state.language]}
                </button>
              </div>
              <button className='button2 borderRadius2 riseOut2' tabindex='0'
                onClick={ async () => {
                  const result = await handleClickSendMona(state, dispatch, props.popupLayer);

                  if (result.status === 'fulfilled') {
                    handleClickGetPurchaseHistory(state, dispatch, cookies, setCookie, 0, null, null);
                  }
                  else if (result?.message === 'nfcRequired') {
                    const callback = async (keyPairs) => {
                      const result = await handleClickSendMona(state, dispatch, props.popupLayer, keyPairs);
                      keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

                      if (result.status === 'fulfilled') {
                        handleClickGetPurchaseHistory(state, dispatch, cookies, setCookie, 0, null, null);
                      }
                    };

                    handleClickNfc(state, dispatch, callback);
                  }
                  else if (result?.message === 'nfcNativeRequired') {
                    const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, popupLayer, language: state.language, network: state.networkMona });

                    const resultWithKeyPairs = await handleClickSendMona(state, dispatch, props.popupLayer, keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

                    if (resultWithKeyPairs.status === 'fulfilled') {
                      handleClickGetPurchaseHistory(state, dispatch, cookies, setCookie, 0, null, null);
                    }
                  }
                  else if (result?.message === 'bcRequired') {
                    const callback = async (keyPairs) => {
                      const result = await handleClickSendMona(state, dispatch, props.popupLayer, keyPairs);
                      keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

                      if (result.status === 'fulfilled') {
                        handleClickGetPurchaseHistory(state, dispatch, cookies, setCookie, 0, null, null);
                      }
                    };

                    handleClickScanQr(state, dispatch, callback, { popupLayer: popupLayer + 1 });
                  }
                }}
              >
                {words.sendMona[state.language]}
              </button>
            </div>
          : null
        }
      </div>
  );
}

// RESUME PURCHASE SIGNING
function ResumePurchaseSigning(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const cookies = useGlobalStateSelector( ({ cookies }) => cookies );
  const setCookie = useGlobalStateSelector( ({ setCookie }) => setCookie );

  return (
      <div className='flexRow justifyContentCenter'>
        {
          ((state.purchase.signatureByAddressPayFrom === undefined ||
            state.purchase.signatureByAddressPayFrom === null ||
            state.purchase.signatureByAddressPayFrom === '') &&
           (state.purchase.exhibitNo !== undefined &&
            state.purchase.exhibitNo !== null &&
            state.purchase.exhibitNo !== '') &&
           state.purchase.status === 'waitingForSignature') ?
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
              onClick={ async () => {
                const result = await handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressPayFrom', props.popupLayer);

                if (result.status === 'fulfilled') {
                  handleClickGetPurchaseHistory(state, dispatch, cookies, setCookie, 0);
                }
                else if (result?.message === 'nfcRequired') {
                  const callback = async (keyPairs) => {
                    const result = await handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressPayFrom', props.popupLayer, keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

                    if (result.status === 'fulfilled') {
                      handleClickGetPurchaseHistory(state, dispatch, cookies, setCookie, 0);
                    }
                  };

                  handleClickNfc(state, dispatch, callback);
                }
                else if (result?.message === 'nfcNativeRequired') {
                  const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, popupLayer: props.popupLayer, language: state.language, network: state.networkMona });

                  const resultWithKeyPairs = await handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressPayFrom', props.popupLayer, keyPairs);
                  keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

                  if (resultWithKeyPairs.status === 'fulfilled') {
                    handleClickGetPurchaseHistory(state, dispatch, cookies, setCookie, 0);
                  }
                }
                else if (result?.message === 'bcRequired') {
                  const callback = async (keyPairs) => {
                    const result = await handleClickSignPurchase(state, dispatch, cookies, setCookie, 'addressPayFrom', props.popupLayer, keyPairs);
                    keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

                    if (result.status === 'fulfilled') {
                      handleClickGetPurchaseHistory(state, dispatch, cookies, setCookie, 0);
                    }
                  };

                  handleClickScanQr(state, dispatch, callback, { popupLayer: props.popupLayer + 1 });
                }
              }}
            >
              <div>
                {words.signByAddressYouPayFrom[state.language]}
              </div>
              <img className='size2x2' src={iconSign} alt='sign'/>
            </button>
          : null
        }
      </div>
  );
}

// SALES RECORD TITLE
function SalesRecordTitle(props) {
  const state = useGlobalStateSelector( ({ state }) => state );

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { words.exhibitNo[state.language] }
          </div>
          <div className='marginSide1 widthMin25' >
            { words.tokenName[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.exhibitorProceedsNetMona[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.amountToBuy[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.exhibitorsTotalNetProceeds[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.purchaserName[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.dateAndTime[state.language] }
          </div>
          <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite' disabled={true} />
        </div>
      </div>
      {/* SP */}
    </div>
  );
}

// SALES RECORD
function SalesRecord(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const record = props.record;
  const assetCommon = record.asset_longname === null ? record.asset : record.asset_longname;

  /* detail */
  const items =
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressMainExhibitor[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressMainExhibitor}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.exhibitNo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.exhibitNo}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.asset[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.asset}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.asset_longname[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.asset_longname}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressMainPurchaser[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressMain}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.purchaserName[state.language]}
          </div>
          <div className='paddingLeft1'>
            {state.usersGeneralIndex[record.addressMain] !== undefined ? state.usersGeneralIndex[record.addressMain].userName : null}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.purchaseNo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.purchaseNo}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressOwner[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressOwner}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.ownerName[state.language]}
          </div>
          <div className='paddingLeft1'>
            {state.usersGeneralIndex[record.addressOwner] !== undefined ? state.usersGeneralIndex[record.addressOwner].userName : null}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressPayRoyaltyTo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressPayRoyaltyTo}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.royaltyRecipientName[state.language]}
          </div>
          <div className='paddingLeft1'>
            {state.usersGeneralIndex[record.addressPayRoyaltyTo] !== undefined ? state.usersGeneralIndex[record.addressPayRoyaltyTo].userName : null}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressPayProceedsTo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressPayProceedsTo}
          </div>
        </div>
        <div className='flexRow boxDetail justifyContentSpaceBetween'>
          <div className='flexColumn '>
            <div>
              {words.addressPurchaserPaysFrom[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.addressPayFrom}
            </div>
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.unitPriceMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.priceMona + ' MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.exhibitorProceedsNetMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            { (new decimal(record.proceedsNetMona)).dividedBy(100000000).toNumber() + ' MONA' }
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.royaltyMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            { (new decimal(record.royaltyMona)).dividedBy(100000000).toNumber() + ' MONA' }
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.feeExhibitMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            { (new decimal(record.feeExhibitMona)).dividedBy(100000000).toNumber() + ' MONA' }
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.feePurchaseMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            { (new decimal(record.feePurchaseMona)).dividedBy(100000000).toNumber() + ' MONA' }
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.amountToBuy[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.amountToBuy}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.exhibitorsTotalNetProceeds[state.language]}
          </div>
          <div className='paddingLeft1'>
            { (new decimal(record.proceedsNetMona * record.amountToBuy)).dividedBy(100000000).toNumber() + ' MONA' }
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.txidOfSendingMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.receiveMonaTxid}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.applicationTimeOfPurchase[state.language]}
          </div>
          <div className='paddingLeft1'>
            {localTime(record.serverTimeOfAddressMain)}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.confirmationTimeOfReceiptOfPayment[state.language]}
          </div>
          <div className='paddingLeft1'>
            {localTime(record.receiveMonaConfirmationTime)}
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='flexColumn alignItemsCenter'>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressMainExhibitor[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressMainExhibitor}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitNo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.exhibitNo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.asset[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.asset_longname[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset_longname}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressMainPurchaser[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressMain}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.purchaserName[state.language]}
            </div>
            <div className='paddingLeft1'>
              {state.usersGeneralIndex[record.addressMain] !== undefined ? state.usersGeneralIndex[record.addressMain].userName : null}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.purchaseNo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.purchaseNo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressOwner[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressOwner}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.ownerName[state.language]}
            </div>
            <div className='paddingLeft1'>
              {state.usersGeneralIndex[record.addressOwner] !== undefined ? state.usersGeneralIndex[record.addressOwner].userName : null}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressPayRoyaltyTo[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressPayRoyaltyTo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.royaltyRecipientName[state.language]}
            </div>
            <div className='paddingLeft1'>
              {state.usersGeneralIndex[record.addressPayRoyaltyTo] !== undefined ? state.usersGeneralIndex[record.addressPayRoyaltyTo].userName : null}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressPayProceedsTo[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressPayProceedsTo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              <div>
                {words.addressPurchaserPaysFrom[state.language]}
              </div>
              <div className='paddingLeft1 breakAll'>
                {record.addressPayFrom}
              </div>
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.unitPriceMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.priceMona + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitorProceedsNetMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              { (new decimal(record.proceedsNetMona)).dividedBy(100000000).toNumber() + ' MONA' }
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.royaltyMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              { (new decimal(record.royaltyMona)).dividedBy(100000000).toNumber() + ' MONA' }
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.feeExhibitMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              { (new decimal(record.feeExhibitMona)).dividedBy(100000000).toNumber() + ' MONA' }
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.feePurchaseMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              { (new decimal(record.feePurchaseMona)).dividedBy(100000000).toNumber() + ' MONA' }
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.amountToBuy[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.amountToBuy}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitorsTotalNetProceeds[state.language]}
            </div>
            <div className='paddingLeft1'>
              { (new decimal(record.proceedsNetMona * record.amountToBuy)).dividedBy(100000000).toNumber() + ' MONA' }
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.txidOfSendingMona[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.receiveMonaTxid}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.applicationTimeOfPurchase[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.serverTimeOfAddressMain)}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.confirmationTimeOfReceiptOfPayment[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.receiveMonaConfirmationTime)}
            </div>
          </div>
        </div>
      </div>
    </div>

  const popup = { type: 'generalItems', body: items };
  const buttons =
    <button className='button1' onClick={ () => { dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup }) } } >
      <img className='size2x2' src={iconDetail} alt='detail' />
    </button>;

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin7' >
            { 'No. ' + props.record.exhibitNo }
          </div>
          <div className='marginSide1 widthMin25' >
            { assetCommon }
          </div>
          <div className='marginSide1 widthMin15' >
            { (new decimal(record.proceedsNetMona)).dividedBy(100000000).toNumber() + ' MONA' }
          </div>
          <div className='marginSide1 widthMin15' >
            { record.amountToBuy }
          </div>
          <div className='marginSide1 widthMin15' >
            { (new decimal(record.proceedsNetMona * record.amountToBuy)).dividedBy(100000000).toNumber() + ' MONA' }
          </div>
          <div className='marginSide1 widthMin15' >
            { state.usersGeneralIndex[record.addressMain] !== undefined ? state.usersGeneralIndex[record.addressMain].userName : null }
          </div>
          <div className='marginSide1 widthMin15' >
            { localTime(record.receiveMonaConfirmationTime, 'yearToMinute') }
          </div>
          { buttons }
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='boxMonacotto1SmallScreen flexColumn alignItemsFlexStart '  >
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.exhibitNo[state.language] }
            </div>
            <div className='flexRow alignItemsCenter' >
              <div className='' >
                { 'No. ' + props.record.exhibitNo }
              </div>
              { buttons }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.tokenName[state.language] }
            </div>
            <div className='' >
              { assetCommon }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.exhibitorProceedsNetMona[state.language] }
            </div>
            <div className='' >
              { (new decimal(record.proceedsNetMona)).dividedBy(100000000).toNumber() + ' MONA' }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.amountToBuy[state.language] }
            </div>
            <div className='' >
              { record.amountToBuy }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.exhibitorsTotalNetProceeds[state.language] }
            </div>
            <div className='' >
              { (new decimal(record.proceedsNetMona * record.amountToBuy)).dividedBy(100000000).toNumber() + ' MONA' }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.purchaserName[state.language] }
            </div>
            <div className='' >
              { state.usersGeneralIndex[record.addressMain] !== undefined ? state.usersGeneralIndex[record.addressMain].userName : null }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.dateAndTime[state.language] }
            </div>
            <div className='' >
              { localTime(record.receiveMonaConfirmationTime, 'yearToMinute') }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ROYALTY RECORD TITLE
function RoyaltyRecordTitle(props) {
  const state = useGlobalStateSelector( ({ state }) => state );

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin15' >
            { words.exhibitorName[state.language] }
          </div>
          <div className='marginSide1 widthMin25' >
            { words.tokenName[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.royalty[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.amountToBuy[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.totalRoyalty[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.purchaserName[state.language] }
          </div>
          <div className='marginSide1 widthMin15' >
            { words.dateAndTime[state.language] }
          </div>
          <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite' disabled={true} />
        </div>
      </div>
      {/* SP */}
    </div>
  );
}

// ROYALTY RECORD
function RoyaltyRecord(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const record = props.record;
  const assetCommon = record.asset_longname === null ? record.asset : record.asset_longname;

  /* detail */
  const items =
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressOwner[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressOwner}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.ownerName[state.language]}
          </div>
          <div className='paddingLeft1'>
            {state.usersGeneralIndex[record.addressOwner] !== undefined ? state.usersGeneralIndex[record.addressOwner].userName : null}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressMainExhibitor[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressMainExhibitor}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.exhibitorName[state.language]}
          </div>
          <div className='paddingLeft1'>
            {state.usersGeneralIndex[record.addressMainExhibitor] !== undefined ? state.usersGeneralIndex[record.addressMainExhibitor].userName : null}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.exhibitNo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.exhibitNo}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.asset[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.asset}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.asset_longname[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.asset_longname}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressMainPurchaser[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressMain}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.purchaserName[state.language]}
          </div>
          <div className='paddingLeft1'>
            {state.usersGeneralIndex[record.addressMain] !== undefined ? state.usersGeneralIndex[record.addressMain].userName : null}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.purchaseNo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.purchaseNo}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressPayRoyaltyTo[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.addressPayRoyaltyTo}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.royaltyRecipientName[state.language]}
          </div>
          <div className='paddingLeft1'>
            {state.usersGeneralIndex[record.addressPayRoyaltyTo] !== undefined ? state.usersGeneralIndex[record.addressPayRoyaltyTo].userName : null}
          </div>
        </div>
        <div className='flexRow boxDetail justifyContentSpaceBetween'>
          <div className='flexColumn '>
            <div>
              {words.addressPurchaserPaysFrom[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.addressPayFrom}
            </div>
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.unitPriceMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.priceMona + ' MONA'}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.royaltyMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            { (new decimal(record.royaltyMona)).dividedBy(100000000).toNumber() + ' MONA' }
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.amountToBuy[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.amountToBuy}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.totalRoyalty[state.language]}
          </div>
          <div className='paddingLeft1'>
            { (new decimal(record.royaltyMona * record.amountToBuy)).dividedBy(100000000).toNumber() + ' MONA' }
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.txidOfSendingMona[state.language]}
          </div>
          <div className='paddingLeft1'>
            {record.receiveMonaTxid}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.applicationTimeOfPurchase[state.language]}
          </div>
          <div className='paddingLeft1'>
            {localTime(record.serverTimeOfAddressMain)}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.confirmationTimeOfReceiptOfPayment[state.language]}
          </div>
          <div className='paddingLeft1'>
            {localTime(record.receiveMonaConfirmationTime)}
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='flexColumn alignItemsCenter'>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressOwner[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressOwner}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.ownerName[state.language]}
            </div>
            <div className='paddingLeft1'>
              {state.usersGeneralIndex[record.addressOwner] !== undefined ? state.usersGeneralIndex[record.addressOwner].userName : null}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressMainExhibitor[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressMainExhibitor}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitorName[state.language]}
            </div>
            <div className='paddingLeft1'>
              {state.usersGeneralIndex[record.addressMainExhibitor] !== undefined ? state.usersGeneralIndex[record.addressMainExhibitor].userName : null}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.exhibitNo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.exhibitNo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.asset[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.asset_longname[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.asset_longname}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressMainPurchaser[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressMain}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.purchaserName[state.language]}
            </div>
            <div className='paddingLeft1'>
              {state.usersGeneralIndex[record.addressMain] !== undefined ? state.usersGeneralIndex[record.addressMain].userName : null}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.purchaseNo[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.purchaseNo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.addressPayRoyaltyTo[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.addressPayRoyaltyTo}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.royaltyRecipientName[state.language]}
            </div>
            <div className='paddingLeft1'>
              {state.usersGeneralIndex[record.addressPayRoyaltyTo] !== undefined ? state.usersGeneralIndex[record.addressPayRoyaltyTo].userName : null}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              <div>
                {words.addressPurchaserPaysFrom[state.language]}
              </div>
              <div className='paddingLeft1 breakAll'>
                {record.addressPayFrom}
              </div>
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.unitPriceMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.priceMona + ' MONA'}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.royaltyMona[state.language]}
            </div>
            <div className='paddingLeft1'>
              { (new decimal(record.royaltyMona)).dividedBy(100000000).toNumber() + ' MONA' }
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.amountToBuy[state.language]}
            </div>
            <div className='paddingLeft1'>
              {record.amountToBuy}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.totalRoyalty[state.language]}
            </div>
            <div className='paddingLeft1'>
              { (new decimal(record.royaltyMona * record.amountToBuy)).dividedBy(100000000).toNumber() + ' MONA' }
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.txidOfSendingMona[state.language]}
            </div>
            <div className='paddingLeft1 breakAll'>
              {record.receiveMonaTxid}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.applicationTimeOfPurchase[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.serverTimeOfAddressMain)}
            </div>
          </div>
          <div className='flexColumn boxMonacotto1SmallScreen width98PC'>
            <div className='width96PC '>
              {words.confirmationTimeOfReceiptOfPayment[state.language]}
            </div>
            <div className='paddingLeft1'>
              {localTime(record.receiveMonaConfirmationTime)}
            </div>
          </div>
        </div>
      </div>
    </div>

  const popup = { type: 'generalItems', body: items };
  const buttons =
    <button className='button1' onClick={ () => { dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup }) } } >
      <img className='size2x2' src={iconDetail} alt='detail' />
    </button>;

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin15' >
            { state.usersGeneralIndex[record.addressMainExhibitor] !== undefined ? state.usersGeneralIndex[record.addressMainExhibitor].userName : null }
          </div>
          <div className='marginSide1 widthMin25' >
            { assetCommon }
          </div>
          <div className='marginSide1 widthMin15' >
            { (new decimal(record.royaltyMona)).dividedBy(100000000).toNumber() + ' MONA' }
          </div>
          <div className='marginSide1 widthMin15' >
            { record.amountToBuy }
          </div>
          <div className='marginSide1 widthMin15' >
            { (new decimal(record.royaltyMona * record.amountToBuy)).dividedBy(100000000).toNumber() + ' MONA' }
          </div>
          <div className='marginSide1 widthMin15' >
            { state.usersGeneralIndex[record.addressMain] !== undefined ? state.usersGeneralIndex[record.addressMain].userName : null }
          </div>
          <div className='marginSide1 widthMin15' >
            { localTime(record.receiveMonaConfirmationTime, 'yearToMinute') }
          </div>
          { buttons }
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='boxMonacotto1SmallScreen flexColumn alignItemsFlexStart '  >
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.exhibitorName[state.language] }
            </div>
            <div className='flexRow alignItemsCenter' >
              { state.usersGeneralIndex[record.addressMainExhibitor] !== undefined ? state.usersGeneralIndex[record.addressMainExhibitor].userName : null }
              { buttons }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.tokenName[state.language] }
            </div>
            <div className='' >
              { assetCommon }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.royalty[state.language] }
            </div>
            <div className='' >
              { (new decimal(record.royaltyMona)).dividedBy(100000000).toNumber() + ' MONA' }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.amountToBuy[state.language] }
            </div>
            <div className='' >
              { record.amountToBuy }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.totalRoyalty[state.language] }
            </div>
            <div className='' >
              { (new decimal(record.royaltyMona * record.amountToBuy)).dividedBy(100000000).toNumber() + ' MONA' }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.purchaserName[state.language] }
            </div>
            <div className='' >
              { state.usersGeneralIndex[record.addressMain] !== undefined ? state.usersGeneralIndex[record.addressMain].userName : null }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.dateAndTime[state.language] }
            </div>
            <div className='' >
              { localTime(record.receiveMonaConfirmationTime, 'yearToMinute') }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// CHANGE EXHIBIT
function ChangeExhibit(props) {
  const popupLayer = props.popupLayer;
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const cookies = useGlobalStateSelector( ({ cookies }) => cookies );

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='flexColumn alignItemsFlexStart'>
          <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop1 '>
            <TextLine3 fieldName='changeExhibitAddressPayProceedsTo' keys={['changeExhibit', 'addressPayProceedsTo']} face={words.addressPayProceedsTo[state.language]} tooltip={true}
              disabled={state.changeExhibit.disabled}
            />
            <SelectSessionButton popupLayer={popupLayer} stateKeysToSetAddress={[['changeExhibit', 'addressPayProceedsTo']]} stateKeysToSetUserName={[]} />
            <button className='button1' disabled={state.changeExhibit.disabled} onClick={ () => handleClickMpurse(state, dispatch, ['changeExhibit', 'addressPayProceedsTo']) }>
              <img className='size2x2' src={iconMpurse} alt='mpurse' />
            </button>
            <button className='button1' disabled={state.changeExhibit.disabled} onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['changeExhibit', 'addressPayProceedsTo'], 0) }>
              <img className='size2x2' src={iconList} alt='list' />
            </button>
          </div>
          <TextLine3 fieldName='changeExhibitPriceMona' keys={['changeExhibit', 'priceMona']} face={words.unitPriceMonaWithUnit[state.language]}
            type='setStateMultiLayersFloat' adjustType='round' adjustExp={priceDigit} disabled={state.changeExhibit.disabled}
          />
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='flexColumn alignItemsFlexStart'>
          <TextLine3 fieldName='changeExhibitAddressPayProceedsTo' keys={['changeExhibit', 'addressPayProceedsTo']} face={words.addressPayProceedsTo[state.language]} tooltip={true}
            disabled={state.changeExhibit.disabled}
          />
          <div className='flexRow justifyContentFlexStart alignItemsCenter marginTopBottom0p5 '>
            <SelectSessionButton popupLayer={popupLayer} stateKeysToSetAddress={[['changeExhibit', 'addressPayProceedsTo']]} stateKeysToSetUserName={[]} />
            <button className='button1' disabled={state.changeExhibit.disabled} onClick={ () => handleClickMpurse(state, dispatch, ['changeExhibit', 'addressPayProceedsTo']) }>
              <img className='size2x2' src={iconMpurse} alt='mpurse' />
            </button>
            <button className='button1' disabled={state.changeExhibit.disabled} onClick={ () => handleClickAddressHistory(state, dispatch, cookies, ['changeExhibit', 'addressPayProceedsTo'], 0) }>
              <img className='size2x2' src={iconList} alt='list' />
            </button>
          </div>
          <TextLine3 fieldName='changeExhibitPriceMona' keys={['changeExhibit', 'priceMona']} face={words.unitPriceMonaWithUnit[state.language]}
            type='setStateMultiLayersFloat' adjustType='round' adjustExp={priceDigit} disabled={state.changeExhibit.disabled}
          />
        </div>
      </div>
    </div>
  );
}

// CANCEL SIGNING
function CancelSigning(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const cookies = useGlobalStateSelector( ({ cookies }) => cookies );
  const setCookie = useGlobalStateSelector( ({ setCookie }) => setCookie );
  const popupLayerNext = props.popupLayer !== undefined && props.popupLayer !== null ? (props.popupLayer + 1) : 0;

  return (
    <div className='flexRow justifyContentCenter alignItemsCenter marginTop1 '>
      {
        (state.cancelExhibit.signatureByAddressMainCancel === undefined ||
         state.cancelExhibit.signatureByAddressMainCancel === null ||
         state.cancelExhibit.signatureByAddressMainCancel === '') &&
        state.cancelExhibit.status === 'waitingForSignature' ?
        <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
          onClick={ async () => {
            const result = await handleClickSignCancelExhibit(state, dispatch, cookies, setCookie);

            if (result.status === 'fulfilled') {
              // const { body: { sessionId, expirationOfSession, cancelExhibit }} = result;
              // const activeCertification = [];

              // if (sessionId.addressMain !== undefined) {
              //   activeCertification.push({ address: cancelExhibit.addressMain, sessionId: sessionId.addressMain, expirationOfSession: expirationOfSession.addressMain });
              // }

              // if (sessionId.addressMainActual !== undefined) {
              //   activeCertification.push({ address: cancelExhibit.addressMainActual, sessionId: sessionId.addressMainActual, expirationOfSession: expirationOfSession.addressMainActual });
              // }

              const activeCertification = buildActiveCertification(result, 'cancelExhibit', ['addressMain', 'addressMainActual']);
              handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, activeCertification);
            }
            else if (result?.message === 'nfcRequired') {
              const callback = async (keyPairs) => {
                const result = await handleClickSignCancelExhibit(state, dispatch, cookies, setCookie, keyPairs);
                keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

                if (result.status === 'fulfilled') {
                  const activeCertification = buildActiveCertification(result, 'cancelExhibit', ['addressMain', 'addressMainActual']);
                  handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, activeCertification);
                }
              };

              handleClickNfc(state, dispatch, callback);
            }
            else if (result?.message === 'nfcNativeRequired') {
              const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, popupLayer: props.popupLayer, language: state.language, network: state.networkMona });

              const resultWithKeyPairs = await handleClickSignCancelExhibit(state, dispatch, cookies, setCookie, keyPairs);
              keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

              if (resultWithKeyPairs.status === 'fulfilled') {
                const activeCertification = buildActiveCertification(resultWithKeyPairs, 'cancelExhibit', ['addressMain', 'addressMainActual']);
                handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, activeCertification);
              }
            }
            else if (result?.message === 'bcRequired') {
              const callback = async (keyPairs) => {
                const result = await handleClickSignCancelExhibit(state, dispatch, cookies, setCookie, keyPairs);
                keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

                if (result.status === 'fulfilled') {
                  const activeCertification = buildActiveCertification(result, 'cancelExhibit', ['addressMain', 'addressMainActual']);
                  handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, activeCertification);
                }
              };

              handleClickScanQr(state, dispatch, callback, { popupLayer: popupLayerNext });
            }
          }}
        >
          <div>
            {words.signByMainAddress[state.language]}
          </div>
          <img className='size2x2' src={iconSign} alt='sign' />
        </button>
        : null
      }
    </div>
  );
}

// CHANGE EXHIBIT SIGNING
function ChangeExhibitSigning(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const cookies = useGlobalStateSelector( ({ cookies }) => cookies );
  const setCookie = useGlobalStateSelector( ({ setCookie }) => setCookie );
  const popupLayerNext = props.popupLayer !== undefined && props.popupLayer !== null ? (props.popupLayer + 1) : 0;

  const onClickSignChangeExhibit = async () => {
    const result = await handleClickSignChangeExhibit(state, dispatch, cookies, setCookie);

    if (result.status === 'fulfilled') {
      const activeCertification = buildActiveCertification(result, 'exhibit', ['addressMain', 'addressMainActual']);
      handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, activeCertification);
    }
    else if (result?.message === 'nfcRequired') {
      const callback = async (keyPairs) => {
        const result = await handleClickSignChangeExhibit(state, dispatch, cookies, setCookie, keyPairs);
        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

        if (result.status === 'fulfilled') {
          const activeCertification = buildActiveCertification(result, 'exhibit', ['addressMain', 'addressMainActual']);
          handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, activeCertification);
        }
      };

      handleClickNfc(state, dispatch, callback);
    }
    else if (result?.message === 'nfcNativeRequired') {
      const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, popupLayer: props.popupLayer, language: state.language, network: state.networkMona });

      const resultWithKeyPairs = await handleClickSignChangeExhibit(state, dispatch, cookies, setCookie, keyPairs);
      keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

      if (resultWithKeyPairs.status === 'fulfilled') {
        const activeCertification = buildActiveCertification(resultWithKeyPairs, 'exhibit', ['addressMain', 'addressMainActual']);
        handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, activeCertification);
      }
    }
    else if (result?.message === 'bcRequired') {
      const callback = async (keyPairs) => {
        const result = await handleClickSignChangeExhibit(state, dispatch, cookies, setCookie, keyPairs);
        keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

        if (result.status === 'fulfilled') {
          const activeCertification = buildActiveCertification(result, 'exhibit', ['addressMain', 'addressMainActual']);
          handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, activeCertification);
        }
      };

      handleClickScanQr(state, dispatch, callback, { popupLayer: popupLayerNext });
    }
  };


  return (
        <div className='flexRow justifyContentCenter alignItemsCenter marginTop1 '>
          {
            (state.changeExhibit.signatureByAddressMainChange === undefined ||
             state.changeExhibit.signatureByAddressMainChange === null ||
             state.changeExhibit.signatureByAddressMainChange === '') &&
            state.changeExhibit.exhibitNo === state.popup[props.popupLayer].body.exhibitNo &&
            state.changeExhibit.status === 'waitingForSignature' ?
            <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0' onClick={ onClickSignChangeExhibit } >
              <div>
                {words.signByMainAddress[state.language]}
              </div>
              <img className='size2x2' src={iconSign} alt='sign' />
            </button>
            : null
          }
        </div>
  );

              /*
              onClick={ async () => {
                const result = await handleClickSignChangeExhibit(state, dispatch, cookies, setCookie);

                if (result.status === 'fulfilled') {
                  // const { body: { sessionId, expirationOfSession }} = result;
                  // handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, { address: state.changeExhibit.addressMain, sessionId, expirationOfSession });

                  const { body: { sessionId, expirationOfSession, exhibit }} = result;
                  const activeCertification = [];

                  if (sessionId.addressMain !== undefined) {
                    activeCertification.push({ address: exhibit.addressMain, sessionId: sessionId.addressMain, expirationOfSession: expirationOfSession.addressMain });
                  }

                  if (sessionId.addressMainActual !== undefined) {
                    activeCertification.push({ address: exhibit.addressMainActual, sessionId: sessionId.addressMainActual, expirationOfSession: expirationOfSession.addressMainActual });
                  }

                  handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, activeCertification);
                }
              }}
              */
}

// RESUME EXHIBIT
function ResumeExhibit(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const cookies = useGlobalStateSelector( ({ cookies }) => cookies );
  const setCookie = useGlobalStateSelector( ({ setCookie }) => setCookie );
  const record = props.record;
  const popupLayer = props.popupLayer;

  return (
    <div className='flexRow justifyContentCenter'>
      {
        state.exhibit.status === 'waitingForToken' && record.sendTokenTx_hashFromClient === undefined ?
          <button className='button2 borderRadius2 riseOut2' tabindex='0'
            onClick={ async () => {
              const result = await handleClickSendToken(state, dispatch);
              devLog('resume exhibit');

              if (result.status === 'fulfilled') {
                devLog('get exhibit history');
                handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, null, null);
              }
              else if (result?.message === 'nfcRequired') {
                const callback = async (keyPairs) => {
                  const result = await handleClickSendToken(state, dispatch ,keyPairs);
                  keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

                  if (result.status === 'fulfilled') {
                    devLog('get exhibit history');
                    handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, null, null);
                  }
                };

                handleClickNfc(state, dispatch, callback);
              }
              else if (result?.message === 'nfcNativeRequired') {
                const { keyPairs } = await getSecretsFromNativeApp({ dispatch, pass: state.config.clientParameters.specialMessage, popupLayer, language: state.language, network: state.networkMona });

                const resultWithKeyPairs = await handleClickSendToken(state, dispatch, keyPairs);
                keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

                if (resultWithKeyPairs.status === 'fulfilled') {
                  devLog('get exhibit history');
                  handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, null, null);
                }
              }
              else if (result?.message === 'bcRequired') {
                const callback = async (keyPairs) => {
                  const result = await handleClickSendToken(state, dispatch ,keyPairs);
                  keepKeyPairsInMemory({ dispatch, keyPairs, periodToKeepKeyPairs: state.config.clientParameters.periodToKeepKeyPairs, language: state.language, network: state.networkMona });

                  if (result.status === 'fulfilled') {
                    devLog('get exhibit history');
                    handleClickGetExhibitHistory(state, dispatch, cookies, setCookie, 0, null, null);
                  }
                };

                handleClickScanQr(state, dispatch, callback, { popupLayer: popupLayer + 1 });
              }
            }}
          >
            {words.sendCards[state.language]}
          </button>
        : null
      }
    </div>
  );
}

export {
  History,
  ExhibitRecordDetailResume,
  ExhibitRecordDetailChange,
  ExhibitRecordDetailFinished,
  PurchaseRecordDetail,
}